import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const cleanEmail = email.trim().toLowerCase();
    const cleanUser = username.trim();
    if (cleanUser.length < 2) { setErr("Username must be at least 2 characters."); setLoading(false); return; }
    if (password.length < 6) { setErr("Password must be at least 6 characters."); setLoading(false); return; }
    try {
      await register(cleanEmail, password, cleanUser);
      toast.success("Account created");
      nav("/discover");
    } catch (e) {
      setErr(formatApiError(e));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid grid-cols-1 md:grid-cols-2">
      <form onSubmit={submit} className="p-8 sm:p-16 flex flex-col justify-center max-w-md mx-auto w-full order-2 md:order-1">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#9CA47E]">◇ New member</div>
        <h1 className="font-heading text-4xl mt-4">Create account</h1>
        <div className="mt-10 space-y-5">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-[#595959]">Username</label>
            <Input data-testid="register-username" required value={username} onChange={(e) => setUsername(e.target.value)} className="rounded-none border-[#E5E5E5] focus-visible:ring-0 focus-visible:border-[#333333] py-6 mt-2" />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-[#595959]">Email</label>
            <Input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none border-[#E5E5E5] focus-visible:ring-0 focus-visible:border-[#333333] py-6 mt-2" />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-[#595959]">Password</label>
            <Input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none border-[#E5E5E5] focus-visible:ring-0 focus-visible:border-[#333333] py-6 mt-2" />
          </div>
          {err && <div data-testid="register-error" className="text-sm text-[#9CA47E] font-body">{err}</div>}
          <Button data-testid="register-submit" disabled={loading} type="submit" className="w-full rounded-none bg-[#333333] hover:bg-[#333] py-6 text-base">
            {loading ? "Creating…" : "Create account"}
          </Button>
          <div className="font-body text-sm text-[#595959]">
            Already a member? <Link to="/login" className="underline underline-offset-4 text-[#333333]">Sign in</Link>
          </div>
        </div>
      </form>
      <div className="hidden md:block bg-[#333333] text-white p-12 relative overflow-hidden order-1 md:order-2">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#9CA47E]">◇ Welcome</div>
        <h2 className="font-heading text-5xl mt-6 leading-tight">Compose<br/>your first<br/><span className="italic">mood</span>.</h2>
        <p className="font-body text-white/60 mt-8 max-w-sm">Free forever for up to 5 sets. Upgrade any time.</p>
        <div className="absolute bottom-8 left-12 font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
          VORASTYLE · 2026 © COLLECTIVE
        </div>
      </div>
    </div>
  );
}
